module.exports = __webpack_public_path__ + "img/logo_pmark.51554fc1.png";